export const GET_APPOINTMENT_PAYMENT_SESSION = "GET_APPOINTMENT_PAYMENT_SESSION";
export const GET_APPOINTMENT_PAYMENT_SESSION_BEGIN = "GET_APPOINTMENT_PAYMENT_SESSION_BEGIN";
export const GET_APPOINTMENT_PAYMENT_SESSION_SUCCESS = "GET_APPOINTMENT_PAYMENT_SESSION_SUCCESS";
export const GET_APPOINTMENT_PAYMENT_SESSION_FAIL = "GET_APPOINTMENT_PAYMENT_SESSION_FAIL";
